import moment from 'moment';
import { bool, func, oneOf, oneOfType, string } from 'prop-types';
import React from 'react';
import { DateRangePicker } from 'react-dates';
import { END_DATE, START_DATE } from 'react-dates/constants';

import { INTERNAL_DATE_FORMAT, UI_DATE_FORMAT } from '../../utils/constants';
import getDatasetFromProps from '../../utils/get-dataset-from-props';

function isOutsideRange() {
  return false;
}

function isDayBlockedForStartDate(day) {
  return day.date() !== 1;
}

function isDayBlockedForEndDate(day) {
  const endOfMonth = moment(day).endOf('month');
  return day.date() !== endOfMonth.date();
}

class MonthRange extends React.Component {
  constructor(props) {
    super(props);

    this.state = { focusedInput: null };

    this.handleChange = this.handleChange.bind(this);
    this.handleFocusChange = this.handleFocusChange.bind(this);
  }

  handleFocusChange(focusedInput) {
    this.setState({ focusedInput });
  }

  handleChange({ startDate, endDate }) {
    const { startName, endName, limitToOneMonth } = this.props;
    this.triggerChange(startName, startDate);
    if (limitToOneMonth && this.state.focusedInput === START_DATE) {
      const newEndDate = startDate.add(1, 'month').subtract(1, 'day');
      this.triggerChange(endName, newEndDate);
    } else {
      this.triggerChange(endName, endDate);
    }
  }

  triggerChange(name, date) {
    this.props.onChange({
      target: {
        name,
        value: date && date.format(INTERNAL_DATE_FORMAT),
        dataset: getDatasetFromProps(this.props),
      },
    });
  }

  render() {
    const { focusedInput } = this.state;

    const {
      startDate,
      endDate,
      startName,
      endName,
      onChange,
      id,
      readOnly,
      disabled,
      limitToOneMonth,
      ...rest
    } = this.props;

    const isDayBlocked =
      focusedInput === END_DATE
        ? isDayBlockedForEndDate
        : isDayBlockedForStartDate;

    return (
      <DateRangePicker
        displayFormat={UI_DATE_FORMAT}
        isDayBlocked={isDayBlocked}
        isOutsideRange={isOutsideRange}
        disabled={readOnly || disabled}
        minimumNights={0}
        {...rest}
        focusedInput={focusedInput}
        startDate={startDate && moment(startDate)}
        startDateId={`${id}-${startName}`}
        endDate={endDate && moment(endDate)}
        endDateId={`${id}-${endName}`}
        onDatesChange={this.handleChange}
        onFocusChange={this.handleFocusChange}
      />
    );
  }
}

MonthRange.propTypes = {
  endDate: string,
  endName: string.isRequired,
  id: string,
  onChange: func,
  readOnly: bool,
  startDate: string,
  startName: string.isRequired,
  disabled: oneOfType([bool, oneOf([START_DATE, END_DATE])]),
  limitToOneMonth: bool,
};

MonthRange.defaultProps = {
  endDate: null,
  id: undefined,
  onChange: () => {},
  readOnly: undefined,
  startDate: null,
  disabled: false,
  limitToOneMonth: false,
};

export default MonthRange;
